import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';
import { MatIcon } from '@angular/material/icon';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatNativeDateModule } from '@angular/material/core';
import { Assistance } from '../../../../core/models/assistance.interface';
import { AssistanceService } from '../../../../core/models/assistanceservice.interface';
import { AssistanceserviceForm } from '../../assistanceservice/assistanceservice-form/assistanceservice-form';
import { AssistanceserviceService } from '../../../../core/services/assistanceservice/assistanceservice-service';
import { ItemSelectorDialog } from '../../../../shared/components/item-selector-dialog/item-selector-dialog';
import { EmployeeService } from '../../../../core/services/employee/employee-service';
import { ItemSelectorResult } from '../../../../core/models/selectordialog.interface';
import { AssignEmployeeService } from '../../../../core/models/employee.interface';
import { FixedassetService } from '../../../../core/services/fixedasset/fixedasset-service';
import { AssignFixedAsset } from '../../../../core/models/fixedasset.interface';
import { InfraestructureService } from '../../../../core/services/infraestructure/infraestructure-service';
import { AssignInfraestructureService } from '../../../../core/models/infraestructure.interface';
import { MatMenuModule } from '@angular/material/menu';
import { AssistanceserviceServiceactivityList } from '../../serviceactivity/assistanceservice-serviceactivity-list/assistanceservice-serviceactivity-list';
import { ServiceactivityService } from '../../../../core/services/serviceactivity/serviceactivity-service';
import { ServiceactivityForm } from '../../serviceactivity/serviceactivity-form/serviceactivity-form';
import { MatDividerModule } from '@angular/material/divider';
import { TermPipe } from '../../../../shared/pipes/term.pipe';
import { TermKey } from '../../../../core/models/terminology.interface';

@Component({
  selector: 'app-assistance-assistanceservice-list',
  imports: [
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgxPaginationModule,
    MatNativeDateModule,
    MatMenuModule,
    AssistanceserviceServiceactivityList,
    MatDividerModule,
    TermPipe,
  ],
  templateUrl: './assistance-assistanceservice-list.html',
  styleUrl: './assistance-assistanceservice-list.scss',
})
export class AssistanceAssistanceserviceList {
  @Input({ required: true }) assistance!: Assistance;
  @Output() changed = new EventEmitter<void>();

  readonly servicesLimit = 5;
  servicePage = 1;
  termKey = TermKey;
  serviceColumns: string[] = [
    'controls',
    'id',
    'name',
    'components',
    'humanResources',
    'fixedAsset',
    'infraestructure',
    'locations',
    'lifePlan',
    'territory',
    'total',
  ];
  expandedServiceRows = new Set<number>();

  constructor(
    private dialog: MatDialog,
    private toastr: ToastrService,
    private assistanceserviceService: AssistanceserviceService,
    private serviceactivityService: ServiceactivityService,
    private employeeService: EmployeeService,
    private fixedassetService: FixedassetService,
    private infraestructureService: InfraestructureService,
  ) {}

  ngOnInit(): void {}

  toggleActivities(service: AssistanceService): void {
    if (this.expandedServiceRows.has(service.id)) {
      this.expandedServiceRows.delete(service.id);
      return;
    }
    this.expandedServiceRows.add(service.id);
  }

  isServiceExpanded(id: number): boolean {
    return this.expandedServiceRows.has(id);
  }

  createServiceactivity(assistenceService: AssistanceService): void {
    this.assistanceserviceService.setAssistanceService(assistenceService);
    this.serviceactivityService.removeServiceActivitySelected();
    const dialogRef = this.dialog.open(ServiceactivityForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data: {
        isCreate: true,
        assistanceId: assistenceService.id,
      },
    });
    dialogRef.afterClosed().subscribe(() => this.changed.emit());
  }

  updateService(service: AssistanceService): void {
    this.assistanceserviceService.setAssistanceService(service);
    const dialogRef = this.dialog.open(AssistanceserviceForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data: { isCreate: false },
    });
    dialogRef.afterClosed().subscribe(() => this.changed.emit());
  }

  deleteService(service: AssistanceService): void {
    if (!confirm('¿Seguro que deseas eliminar este servicio de asistencia?')) return;
    this.assistanceserviceService.delete(service.id).subscribe({
      next: () => {
        this.toastr.success('Eliminado CORRECTAMENTE!', 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.changed.emit();
      },
      error: () => {
        this.toastr.error('NO se pudo eliminar!', 'Error!', {
          progressBar: true,
          timeOut: 5000,
        });
      },
    });
  }

  openAssignCargo(service: AssistanceService): void {
    this.assistanceserviceService.getById(service.id).subscribe((full) => {
      const itemsIniciales = Array.from(
        new Map(
          full.humanResources.flatMap((hr) =>
            hr.employee.map((emp) => [
              emp.id,
              {
                id: emp.id,
                name: emp.name,
                unitValue: hr.expense?.value ?? 0,
                qty: hr.expense?.qty ?? 0,
                assignmentId: hr.id,
                exists: true,
              },
            ]),
          ),
        ).values(),
      );
      const assignmentByEmployeeId = new Map<number, number>(
        itemsIniciales.map((item) => [Number(item.id), item.assignmentId]),
      );

      const dialogRef = this.dialog.open(ItemSelectorDialog, {
        width: '1000px',
        maxWidth: '95vw',
        maxHeight: '80vh',
        disableClose: true,
        data: {
          title: 'Cargo(s)',
          labelSearch: 'Cargo',
          labelItem: 'Cargo',
          labelValue: 'Salario',
          itemsIniciales,
          showUnity: false,
          showPackage: false,
          uploadItems: () =>
            this.employeeService.getEmployees().pipe(
              map((employees) =>
                employees.map((employee) => ({
                  id: employee.id,
                  name: employee.name,
                  unitValue: employee.monthSalary,
                })),
              ),
            ),
        },
      });

      dialogRef.afterClosed().subscribe((result: ItemSelectorResult | undefined) => {
        if (!result) return;
        const finalItems = result.items ?? [];
        const finalEmployeeIds = new Set(finalItems.map((it) => Number(it.id)));

        const upsertRequests = finalItems.map((item) => {
          const employeeId = Number(item.id);
          const payload: AssignEmployeeService = {
            assistanceService: service.id,
            employees: [employeeId],
            value: item.unitValue,
            qty: item.qty,
            unity: item.unity ?? 'N/A',
            package: item.package ?? 0,
          };
          const assignmentId = assignmentByEmployeeId.get(employeeId);
          const request$ =
            assignmentId !== undefined
              ? this.employeeService.updateAddEmployee(assignmentId, {
                  ...payload,
                  id: assignmentId,
                })
              : this.employeeService.addEmployee(payload);
          return request$.pipe(
            map(() => true),
            catchError(() => of(false)),
          );
        });

        const deleteRequests = [...assignmentByEmployeeId.entries()]
          .filter(([employeeId]) => !finalEmployeeIds.has(employeeId))
          .map(([, assignmentId]) =>
            this.employeeService.deleteAssignEmploye(assignmentId).pipe(
              map(() => true),
              catchError(() => of(false)),
            ),
          );

        this.runAssignmentRequests([...upsertRequests, ...deleteRequests], () =>
          this.changed.emit(),
        );
      });
    });
  }

  openAssignFixedAssets(service: AssistanceService): void {
    this.assistanceserviceService.getById(service.id).subscribe((full) => {
      const itemsIniciales = Array.from(
        new Map(
          full.FixedAssetExpense.flatMap((fa) =>
            fa.fixedAsset.map((asset) => [
              asset.id,
              {
                id: asset.id,
                name: asset.name,
                unitValue: fa.expense?.value ?? 0,
                qty: fa.expense?.qty ?? 0,
                assignmentId: fa.id,
                exists: true,
              },
            ]),
          ),
        ).values(),
      );
      const assignmentByAssetId = new Map<number, number>(
        itemsIniciales.map((item) => [Number(item.id), item.assignmentId]),
      );

      const dialogRef = this.dialog.open(ItemSelectorDialog, {
        width: '1000px',
        maxWidth: '95vw',
        maxHeight: '80vh',
        disableClose: true,
        data: {
          title: 'Activo fijo',
          labelSearch: 'Activo fijo',
          labelItem: 'Activo fijo',
          labelValue: 'Valor',
          itemsIniciales,
          showUnity: false,
          showPackage: false,
          showValueColumn: true,
          uploadItems: () =>
            this.fixedassetService.getFixedAssets().pipe(
              map((fixedAssets) =>
                fixedAssets.map((fixedAsset) => ({
                  id: fixedAsset.id,
                  name: fixedAsset.name,
                })),
              ),
            ),
        },
      });

      dialogRef.afterClosed().subscribe((result: ItemSelectorResult | undefined) => {
        if (!result) return;
        const finalItems = result.items ?? [];
        const finalFixedAssetIds = new Set(finalItems.map((it) => Number(it.id)));

        const upsertRequests = finalItems.map((item) => {
          const fixedAssetId = Number(item.id);
          const payload: AssignFixedAsset = {
            AssistanceService: service.id,
            fixedAsset: [fixedAssetId],
            value: item.unitValue ?? 0,
            qty: item.qty,
            unity: item.unity ?? 'N/A',
            package: item.package ?? 0,
          };
          const assignmentId = assignmentByAssetId.get(fixedAssetId);
          const request$ =
            assignmentId !== undefined
              ? this.fixedassetService.updateAddFixedAsset(assignmentId, {
                  ...payload,
                  id: assignmentId,
                })
              : this.fixedassetService.addFixedAsset(payload);
          return request$.pipe(
            map(() => true),
            catchError(() => of(false)),
          );
        });

        const deleteRequests = [...assignmentByAssetId.entries()]
          .filter(([assetId]) => !finalFixedAssetIds.has(assetId))
          .map(([, assignmentId]) =>
            this.fixedassetService.deleteAssignFixedAsset(assignmentId).pipe(
              map(() => true),
              catchError(() => of(false)),
            ),
          );

        this.runAssignmentRequests([...upsertRequests, ...deleteRequests], () =>
          this.changed.emit(),
        );
      });
    });
  }

  openAssignInfraestructure(service: AssistanceService): void {
    this.assistanceserviceService.getById(service.id).subscribe((full) => {
      const itemsIniciales = Array.from(
        new Map(
          full.infraestructure.flatMap((hr) =>
            hr.infraestructure.map((infra) => [
              infra.id,
              {
                id: infra.id,
                name: infra.name,
                unitValue: hr.expense?.value ?? 0,
                qty: hr.expense?.qty ?? 0,
                unity: hr.expense?.unity ?? '',
                assignmentId: hr.id,
                exists: true,
              },
            ]),
          ),
        ).values(),
      );
      const assignmentByInfraestructureId = new Map<number, number>(
        itemsIniciales.map((item) => [Number(item.id), item.assignmentId]),
      );

      const dialogRef = this.dialog.open(ItemSelectorDialog, {
        width: '1000px',
        maxWidth: '95vw',
        maxHeight: '80vh',
        disableClose: true,
        data: {
          title: 'Infraestructura',
          labelSearch: 'Infraestructura',
          labelItem: 'Infraestructura',
          labelValue: 'Valor',
          itemsIniciales,
          showUnity: false,
          showPackage: false,
          showUnityColumn: true,
          showValueColumn: true,
          uploadItems: () =>
            this.infraestructureService.getInfraestructures().pipe(
              map((infraestructures) =>
                infraestructures.map((infraestructure) => ({
                  id: infraestructure.id,
                  name: infraestructure.name,
                })),
              ),
            ),
        },
      });

      dialogRef.afterClosed().subscribe((result: ItemSelectorResult | undefined) => {
        if (!result) return;
        const finalItems = result.items ?? [];
        const finalInfraestructureIds = new Set(finalItems.map((it) => Number(it.id)));

        const upsertRequests = finalItems.map((item) => {
          const infraestructureId = Number(item.id);
          const payload: AssignInfraestructureService = {
            assistanceService: service.id,
            infraestructures: [infraestructureId],
            value: item.unitValue ?? 0,
            qty: item.qty,
            unity: item.unity ?? 'N/A',
            package: item.package ?? 0,
          };
          const assignmentId = assignmentByInfraestructureId.get(infraestructureId);
          const request$ =
            assignmentId !== undefined
              ? this.infraestructureService.updateAddInfraestructure(assignmentId, {
                  ...payload,
                  id: assignmentId,
                })
              : this.infraestructureService.addInfraestructure(payload);
          return request$.pipe(
            map(() => true),
            catchError(() => of(false)),
          );
        });

        const deleteRequests = [...assignmentByInfraestructureId.entries()]
          .filter(([infraestructureId]) => !finalInfraestructureIds.has(infraestructureId))
          .map(([, assignmentId]) =>
            this.infraestructureService.deleteAssignInfraestructure(assignmentId).pipe(
              map(() => true),
              catchError(() => of(false)),
            ),
          );

        this.runAssignmentRequests([...upsertRequests, ...deleteRequests], () =>
          this.changed.emit(),
        );
      });
    });
  }

  private runAssignmentRequests(requests: Observable<boolean>[], onDone: () => void): void {
    if (requests.length === 0) {
      onDone();
      return;
    }
    forkJoin(requests).subscribe((res) => {
      const exitosos = res.filter(Boolean).length;
      if (exitosos === res.length) {
        this.toastr.success('Se guardaron los cambios correctamente', 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
      } else if (exitosos > 0) {
        this.toastr.warning(`Se aplicaron ${exitosos} de ${res.length} cambios`, 'Parcial', {
          progressBar: true,
          timeOut: 5000,
        });
      } else {
        this.toastr.error('No se pudieron guardar los cambios', 'Error!', {
          progressBar: true,
          timeOut: 5000,
        });
      }
      onDone();
    });
  }
}
